// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__R_I2X","right":"styles_right__eLcl9"};